import React, { useEffect, useState, useMemo } from "react";
import { getFromLocalStorage, setToLocalStorage } from "../../utils/common-utils";
import Swal from "sweetalert2";
import { updateUserProfile, getCountryCodeList } from "../../api/Api"; // Update import
// import "./updateProfile.css";


export default function UpdateProfile({ onHide }) {
  const [updateProfileModal, setUpdateProfileModal] = React.useState(false);
  const [countryList, setCountryList] = useState([]);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    phonecode: 91,
    msisdnLength: 10,
  });
  const [phoneError, setPhoneError] = useState("");

  const [profileDetails, setProfileDetails] = useState({});

  const isAdminProfile = profileDetails.cpDetailsList?.length > 0;

  // Get filtered countries
  const filteredCountries = useMemo(() => {
    return countryList.filter(
      (country) =>
        country.name.toLowerCase().includes(searchCountry.toLowerCase()) ||
        country.phonecode.toString().includes(searchCountry)
    );
  }, [countryList, searchCountry]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get profile data
        const userData = getFromLocalStorage("userData");

        // Get country list
        const response = await getCountryCodeList();
        if (response?.countryList) {
          setCountryList(response.countryList);

          // If mobile number exists, try to match country code
          if (userData?.mobileNo) {
            const mobileNo = userData.mobileNo;

            // Try different lengths of country codes (from longest to shortest)
            let foundCountry = null;
            const numberWithoutPlus = mobileNo.startsWith("+")
              ? mobileNo.substring(1)
              : mobileNo;

            // Sort countries by phonecode length (descending) to match longer codes first
            const sortedCountries = [...response.countryList].sort(
              (a, b) =>
                b.phonecode.toString().length - a.phonecode.toString().length
            );

            for (const country of sortedCountries) {
              const phoneCode = country.phonecode.toString();
              if (numberWithoutPlus.startsWith(phoneCode)) {
                const remainingNumber = numberWithoutPlus.substring(
                  phoneCode.length
                );
                // Verify if remaining number length matches msisdnLength
                if (remainingNumber.length === country.msisdnLength) {
                  foundCountry = country;
                  // Update mobile number without country code
                  setProfileDetails({
                    ...userData,
                    mobileNo: remainingNumber,
                  });
                  break;
                }
              }
            }

            if (foundCountry) {
              setSelectedCountry(foundCountry);
            }
          } else {
            setProfileDetails(userData || {});
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  // Add click outside handler to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".country-selector")) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Add validation in handlePhoneChange
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= selectedCountry.msisdnLength) {
      setProfileDetails((prev) => ({
        ...prev,
        mobileNo: value,
      }));
    }
  };

  // Add validation in handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (profileDetails.mobileNo.length !== selectedCountry.msisdnLength) {
      Swal.fire({
        icon: "error",
        title: "Invalid Phone Number",
        text: `Please enter ${selectedCountry.msisdnLength} digits for ${selectedCountry.name}`,
      });
      return;
    }

    // Basic validation
    if (
      !profileDetails.firstName ||
      !profileDetails.lastName ||
      !profileDetails.email ||
      !profileDetails.mobileNo
    ) {
      Swal.fire({
        icon: "warning",
        text: "Please fill in all required fields",
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(profileDetails.email)) {
      Swal.fire({
        icon: "warning",
        text: "Please enter a valid email address",
      });
      return;
    }

    try {
      const formattedMobile = `+${selectedCountry.phonecode}${profileDetails.mobileNo}`;
      const payload = {
        ...profileDetails,
        mobileNo: formattedMobile,
      };

      const response = await updateUserProfile(payload);
      console.log("responsessssb", response);
      if (response.statusDescription.status === 200) {
        // Update localStorage with new data
        const updatedUserData = {
          ...profileDetails,
          mobileNo: formattedMobile,
          firstName: profileDetails.firstName,
          lastName: profileDetails.lastName,
          email: profileDetails.email,
        };
        setToLocalStorage("userData", updatedUserData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.statusDescription?.description,
        });
        onHide();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.statusDescription?.description || "Failed to update profile",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update profile",
      });
    }
  };

  console.log("profileDetails", profileDetails?.mobileNo);
  return (
    // <div className="modal-body update_profile">
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <div className="row w-100 m-0">
          <div className="col-sm-4">
            <div className="form-group">
              <label>
                First Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="First Name"
                value={profileDetails.firstName || ""}
                onChange={(e) =>
                  setProfileDetails((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
                required
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>
                Last Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Last Name"
                value={profileDetails.lastName || ""}
                onChange={(e) =>
                  setProfileDetails((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
                required
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>
                Email Id<span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Email Id"
                value={profileDetails.email || ""}
                onChange={(e) =>
                  setProfileDetails((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                required
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                disabled
                value={profileDetails.username || ""}
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>
                Mobile<span className="text-danger">*</span>
              </label>
              <div className="phone-input-container">
                {/* Country Selector */}
                <div className="country-selector" onClick={(e) => e.stopPropagation()}>
                  <div
                    className="selected-country"
                    onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                  >
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry?.iso?.toLowerCase()}.png`}
                      alt={selectedCountry?.name}
                      className="country-flag"
                    />
                    <span className="country-code">+{selectedCountry.phonecode}</span>
                    {/* <span className="dropdown-arrow">▼</span> */}
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </div>
                  {showCountryDropdown && (
                    <div className="country-dropdown">
                      <div className="search-container">
                        <input
                          type="text"
                          className="country-search"
                          placeholder="Search country..."
                          value={searchCountry}
                          onChange={(e) => setSearchCountry(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="country-list">
                        {filteredCountries.map((country) => (
                          <div
                            key={country.id}
                            className="country-item"
                            onClick={() => {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                              alt={country?.name}
                              className="country-flag"
                            />
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">+{country.phonecode}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Phone Number Input */}
                <input
                  type="text"
                  className="form-control phone-input"
                  placeholder={`Enter ${selectedCountry.msisdnLength} digit mobile number`}
                  value={profileDetails.mobileNo || ""}
                  onChange={handlePhoneChange}
                  required
                  maxLength={selectedCountry.msisdnLength}
                />
              </div>
              {/* <small className="form-text text-muted">
                Enter {selectedCountry.msisdnLength} digit mobile number
              </small> */}
            </div>
          </div>
        </div>

        {/* <div className="row"> */}
          {/* <div className="col-sm-4">
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                disabled
                value={profileDetails.username || ""}
              />
            </div>
          </div> */}
          {/* <div className="col-sm-4">
            <div className="form-group">
              <label>
                Mobile<span className="text-danger">*</span>
              </label>
              <div className="phone-input-container">
                <div className="country-selector">
                  <div
                    className="selected-country"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowCountryDropdown(!showCountryDropdown);
                    }}
                  >
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry?.iso?.toLowerCase()}.png`}
                      alt={selectedCountry?.name}
                      className="country-flag"
                    />
                    <span className="country-code">
                      +{selectedCountry.phonecode}
                    </span>
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  {showCountryDropdown && (
                    <div className="country-dropdown">
                      <div className="search-container">
                        <input
                          type="text"
                          className="country-search"
                          placeholder="Search country..."
                          value={searchCountry}
                          onChange={(e) => setSearchCountry(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="country-list">
                        {filteredCountries.map((country) => (
                          <div
                            key={country.id}
                            className="country-item"
                            onClick={() => {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                              alt={country?.name}
                              className="country-flag"
                            />
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">
                              +{country.phonecode}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  className="form-control phone-input"
                  placeholder={`Enter ${selectedCountry.msisdnLength} digit mobile number`}
                  value={profileDetails.mobileNo || ""}
                  onChange={handlePhoneChange}
                  required
                  maxLength={selectedCountry.msisdnLength}
                />
              </div>
              <small className="form-text text-muted">
                Enter {selectedCountry.msisdnLength} digit mobile number
              </small>
            </div>
          </div> */}
          {/* <div className="col-sm-4">
            <div className="form-group">
              <label>
                Mobile<span className="text-danger">*</span>
              </label>
              <div className="phone-input-container">
                <div className="country-selector" onClick={(e) => e.stopPropagation()}>
                  <div
                    className="selected-country"
                    onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                  >
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry?.iso?.toLowerCase()}.png`}
                      alt={selectedCountry?.name}
                      className="country-flag"
                    />
                    <span className="country-code">+{selectedCountry.phonecode}</span>
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </div>
                  {showCountryDropdown && (
                    <div className="country-dropdown">
                      <div className="search-container">
                        <input
                          type="text"
                          className="country-search"
                          placeholder="Search country..."
                          value={searchCountry}
                          onChange={(e) => setSearchCountry(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="country-list">
                        {filteredCountries.map((country) => (
                          <div
                            key={country.id}
                            className="country-item"
                            onClick={() => {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                              alt={country?.name}
                              className="country-flag"
                            />
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">+{country.phonecode}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <input
                  type="text"
                  className="form-control phone-input"
                  placeholder={`Enter ${selectedCountry.msisdnLength} digit mobile number`}
                  value={profileDetails.mobileNo || ""}
                  onChange={handlePhoneChange}
                  required
                  maxLength={selectedCountry.msisdnLength}
                />
              </div>
         
            </div>
          </div> */}

          {/* ... rest of your existing fields ... */}
        {/* </div> */}

        {/* ... rest of your existing admin profile fields ... */}

        <div className="modal-footer pb-0 border-0 justify-content-between mx-0 px-0  buttons_divs">
          <button
            type="button"
            className="btn btn-danger btn-raised m-0"
            onClick={onHide}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary btn-raised m-0">
            Update
          </button>
        </div>
      </form>
    // </div>
  );
}
